import PropTypes from 'prop-types';
import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';


const SwitchFieldComponent = ({
  id, label, labelPlacement,
  input: { name, value, onChange },
  meta: { touched, error, warning },
  ...restProps
}) => (
  <FormControlLabel
    control={
      <Switch
        color="primary"
        checked={!!value}
        id={id}
        {...restProps}
        onChange={e => onChange(e.target.checked)}
      />
    }
    label={label}
    labelPlacement={labelPlacement}
  />
);

SwitchFieldComponent.propTypes = {
  id: PropTypes.string.isRequired,
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
  }).isRequired,
  label: PropTypes.string.isRequired,
  labelPlacement: PropTypes.string,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool.isRequired,
    warning: PropTypes.string,
  }).isRequired,
};

SwitchFieldComponent.defaultProps = {
  labelPlacement: 'end',
};

export default SwitchFieldComponent;
